import { Logger } from './logger';
import { Subject } from "rxjs"

type DeviceClockLeapDetectorStateId = "Initial" | "AwaitingTimer"

interface ClockLeapDetectorState {
    id: DeviceClockLeapDetectorStateId,
    timer?: number,
    expectedClockValue?: Date,
}

export class DeviceClockLeapDetector {

    private readonly LOG_TAG = "DeviceClockLeapDetector";
    private state: ClockLeapDetectorState = {
        id: "Initial"
    };

    public constructor(readonly logger: Logger) {
    }


    private readonly deviceClockLeapSubject = new Subject<void>();
    public get $clockLeap() {
        return this.deviceClockLeapSubject.asObservable();
    }

    private passesExpectedClockCheck(state: ClockLeapDetectorState) : boolean {
        if (!(state.expectedClockValue)) {
            return true;
        }
        return Math.abs((new Date()).getTime() - state.expectedClockValue.getTime()) <= 1000;
    }

    private onTimeout(timerId: number) {
        if(this.state.timer === timerId) {
            if (!this.passesExpectedClockCheck(this.state)) {
                this.deviceClockLeapSubject.next();
            }
            this.resetTimer();
        }
    }

    private resetTimer() {
        if(this.state.timer) {
            try {
                window.clearTimeout(this.state.timer);
            } catch (e) {
                this.logger.error(this.LOG_TAG, `Unexpected exception when clearing timeout ${e}`);
            }
        }
        const milliseconds = 60 * 1000;
        const timeoutId = window.setTimeout(
            () => this.onTimeout(timeoutId),
            milliseconds
        );
        this.state = {
            id: "AwaitingTimer",
            expectedClockValue: new Date(new Date().getTime() + milliseconds),
            timer: timeoutId
        };
    }

    public commenceDetection() {
        if (this.state.id == "Initial") {
            this.resetTimer();
        }
    }
}